///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../../helpers/messages";

export const AnalyticsSummary = ({
  inboundToOutboundRatio,
  volumeToCarrierRatio,
  averageCost,
  averageCPM,
  currency
}) => {
  return (
    <>
      <div className="label">{messages.inboundToOutbound.defaultMessage}</div>
      <div data-testid="io-ratio" className="value">
        {inboundToOutboundRatio}
      </div>

      <div className="label">{messages.volumeToCarrier.defaultMessage}</div>
      <div data-testid="vc-ratio" className="value">
        {volumeToCarrierRatio}
      </div>

      <div className="label">{messages.averageCost.defaultMessage}</div>
      <div data-testid="average-cost" className="value">
        {currency}
        {averageCost}
      </div>

      <div className="label">{messages.averageCpm.defaultMessage}</div>
      <div data-testid="average-cpm" className="value">
        {currency}
        {averageCPM}
      </div>
    </>
  );
};

export default AnalyticsSummary;
